import { fromJS, List, Record } from 'immutable';
import _ from 'lodash';

import { AmountCurrencies, CurrencyCode } from 'utils/currencyFormat';

const properties = {
  id: '',
  title: '',
  budget: undefined,
  type: undefined,
  limitTotal: undefined,
  currencyCode: undefined,
  totalIssued: 0,
  totalIssuedCurrencies: undefined,
  corporateDonationsCount: 0,
  volunteerRewardDonationsCount: 0,
  startingAt: undefined,
  endingAt: undefined,
  limitPerUser: undefined,
  rewardAmount: undefined,
  isAmountPerHour: true,
  locations: [],
  locationsExclude: true,
  __t: undefined,
};

export default class BudgetAllocation extends Record(properties, 'BudgetAllocation') {
  public readonly id!: string;

  public readonly title!: string;

  public readonly type!: string;

  public readonly budget!: string;

  public readonly limitTotal!: number;

  public readonly currencyCode!: CurrencyCode;

  public readonly totalIssued!: number;

  public readonly totalIssuedCurrencies!: AmountCurrencies;

  public readonly corporateDonationsCount!: number;

  public readonly volunteerRewardDonationsCount!: number;

  public readonly startingAt!: Date;

  public readonly endingAt!: Date;

  public readonly limitPerUser!: number;

  public readonly locations!: List<string>;

  public readonly locationsExclude!: boolean;

  public readonly rewardAmount!: number;

  public readonly isAmountPerHour!: boolean;

  public readonly __t!: string;

  constructor(values: any = {}) {
    const validValues = _.pick(values, Object.keys(properties));
    super({
      ...validValues,
      startingAt: values.startingAt ? new Date(values.startingAt) : undefined,
      endingAt: values.endingAt ? new Date(values.endingAt) : undefined,
      budget: values.budget.id || values.budget,
      locations: fromJS(values.locations || []),
      type: values.__t,
    });
  }

  get isActive() {
    const referenceDate = new Date();

    return (
      (this.startingAt ? this.startingAt <= referenceDate : true) &&
      (this.endingAt ? this.endingAt >= referenceDate : true)
    );
  }

  toForm() {
    const form = this.toJS();
    return form;
  }

  static fromFormToRequestJson(form) {
    return form;
  }
}
